export default __webpack_public_path__ + "static/media/Nie_logo.79d9656b.jpg";